<template>
  <div>
    <b-overlay :show="$store.state.isLoadingPriData" rounded="sm">
      <b-tabs content-class="mt-3">
        <b-tab title="PRI Risk Categories">
          <b-row>
            <b-col cols="3">
              <b-form-group class="text-left" label="Subscribed Risk Categories">
                <b-form-checkbox
                  v-for="(categories,index) in dueDiligenceCategoriesOption"
                  :key="index"
                  v-model="categories.is_selected"
                  :value="'1'"
                >{{categories.text}}</b-form-checkbox>
              </b-form-group>
              <b-btn size="sm" variant="success" @click="subscribeRiskCategories">
                <b-spinner v-if="submitted" type="grow" label="Loading..."></b-spinner>Update
              </b-btn>
            </b-col>
            <b-col cols="9">
              <b-navbar toggleable="lg" variant="light">
                <b-navbar-brand
                  href="#"
                >{{clientData && clientData.company_name}} - Configurable PRI's</b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                  <b-navbar-nav class="ml-auto">
                    <b-button
                      @click="onAddPriModalClick"
                      size="sm"
                      class="my-2 my-sm-0"
                      variant="outline-primary"
                      type="button"
                    >Add</b-button>
                  </b-navbar-nav>
                </b-collapse>
              </b-navbar>
              <div style="height:370px; overflow-y:auto;">
                <b-table
                  class="mx-1"
                  bordered
                  sticky-header="calc(100vh - 270px)"
                  ref="table"
                  id="my-table"
                  :fixed="true"
                  :busy.sync="$store.state.isLoadingPriData"
                  :items="$store.state.clientAllPriItems"
                  :fields="fieldsPrIList"
                  responsive="sm"
                >
                  <template v-slot:cell(title)="data">{{data.item.title ? data.item.title : null}}</template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      class="mx-1"
                      @click="onEditPriModalClick(data)"
                      variant="outline-info"
                      size="sm"
                    >
                      <font-awesome-icon icon="edit"></font-awesome-icon>
                    </b-button>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Policy Workflow Configuration">
            1. beforeCreate
                Check if third party exists (ajax on the form)
            2. beforeProcess
                check black list
                preclassification
                KYP
            3. Onprocess

            4. After process

            Add third party - >
            PRI - 
                  if low or medium run IDD,IDD+,EDD

                  If high IDD, IDD+, IDD+
            Screening
              IDD,IDD+,EDD
            DDQ,
            ABC -
        </b-tab>
        <b-tab title="Manage Third Parties">
          
        </b-tab>
        <b-tab title="Aliases">
          
        </b-tab>
        <b-tab title="Third party onboarding form">
          
        </b-tab>
        <b-tab title="Third party profile">
          
        </b-tab>
        <b-tab title="MIS Page">
          
        </b-tab>
        <b-tab title="Menu">
          
        </b-tab>
      </b-tabs>
    </b-overlay>

    <!-- ------------------------------------------------------ ADD PRI MOdal ------------------------------------- ------------------ ------------------ ------------------ ------------------->
    <AddPriComponent :platformPriSettings="false" :clientPriSettings="true" />
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import AddPriComponent from "../../components/Pri/addPriModal/addPriModal.vue";
import { EventBus } from "@/event-bus.js";
import { Helper } from "../../helpers";
export default {
  name: "ClientProfileConfiguration",
  components: {
    AddPriComponent
  },
  data() {
    return {
      clientData: null,
      showAddPriModal: false,
      isLoadingPriData: false,
      isEditPri: false,
      isViewPri: false,

      /**
       * Client Pris
       */
      priItems: [],
      submitted: false,
      dueDiligenceCategoriesOption: [],
      fieldsPrIList: [
        { key: "id", label: "id", sortable: true },
        { key: "created_at", label: "Age", sortable: true },
        { key: "created_by.name", label: "Creator", sortable: true },
        { key: "title", label: "Title", sortable: true },
        { key: "pri_categories.name", label: "Categories", sortable: true },
        { key: "actions", sortable: false }
      ]
    };
  },
  computed: {},
  beforeCreated() {},

  created() {},
  mounted() {
    this.getClientPri();
    this.getClientCustomPriFields();
    this.getDueDiligenceCategoriesOptions();
    this.getSubscribeRiskCategories();
  },
  beforeDestroy() {},
  destroy() {},
  methods: {
    async getClientCustomPriFields() {
      let token = "Bearer " + localStorage.getItem("accessToken");

      this.isLoadingPriData = true;
      try {
        let result = await HTTP(
          "get",
          "v1/pri/getclientcustomprifields/" + this.$route.params.id,
          null,
          {
            Authorization: token
          },
          null,
          true
        );
        this.clientData = result.data.client;
        this.isLoadingPriData = false;
      } catch {
        this.isLoadingPriData = false;
        this.showErrorToast = true;
      }
    },
    async getClientPri() {
      this.$store.state.isLoadingPriData = true;
      let token = "Bearer " + localStorage.getItem("accessToken");

      try {
        let result = await HTTP(
          "get",
          "v1/client-pri/all/" + parseInt(this.$route.params.id),
          null,
          {
            Authorization: token
          },
          null,
          true
        );

        this.$store.state.clientAllPriItems = result.data.pri;
        this.$store.state.isLoadingPriData = false;
      } catch {
        this.$store.state.isLoadingPriData = false;

        this.showErrorToast = true;
      }
    },
    async getDueDiligenceCategoriesOptions() {
      this.dueDiligenceCategoriesOption = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/get/due/diligence/categories",
          null,
          {
            Authorization: token
          }
        );
        this.dueDiligenceCategoriesOption = result.data.DueDiligenceCategories;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    async subscribeRiskCategories() {
      let formData = {
        company_id: this.$route.params.id,
        pri_risk_categories: this.dueDiligenceCategoriesOption
      };
      try {
        this.submitted = true;
        let token = "Bearer " + localStorage.getItem("accessToken");
        let result = await HTTP(
          "post",
          "v1/pri/add-risk-categories",
          formData,
          {
            Authorization: token
          }
        );
        if (
          result.data.httpStatus == 200 &&
          result.data.success == 1 &&
          result.status == 200
        ) {
          Helper.makeToast(this.$bvToast, "success", "Risk Categories Updated");
          this.submitted = false;
        } else {
          this.submitted = false;
          Helper.makeToast(this.$bvToast, "danger", "Error");
        }
      } catch (err) {
        // console.log("------------erroror", err);
      }
    },
    async getSubscribeRiskCategories() {
      this.dueDiligenceCategoriesOption = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/pri/get-risk-categories/" + this.$route.params.id,
          null,
          {
            Authorization: token
          }
        );
        if (result && result.status == 200 && result.data.risk_categories) {
          this.dueDiligenceCategoriesOption = JSON.parse(
            result.data.risk_categories
          );
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    onAddPriModalClick() {
      EventBus.$emit("onShowAddModal", "");
    },

    onEditPriModalClick(selectedPri) {
      EventBus.$emit("onShowEditModal", selectedPri);
    }
  }
};
</script>

<style scoped>
</style>
